import familly from '../assets/family.svg';

const MyTree = () => {
  return (
    <>
      <div>
        <img src={familly} alt={'hi'} />
      </div>
    </>
  );
};

export default MyTree;
